import { useEffect, useState } from "react";
import {  Button, Col, Form, InputGroup, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios"
import getCsrfToken from "../clients/features/get_csrfToken";
import { XCircle } from 'react-bootstrap-icons'; // Si tu veux une belle icône (ou utilise une autre lib comme Lucide, FontAwesome, etc.)



export default function HotelForm(){
    const navigate= useNavigate()
    const userParams= useParams()
    const [verifSystem, updateVerifSystem]= useState(false)
    const [selectedPhotos, setSelectedPhotos] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [equipmentInput, setEquipmentInput] = useState({});
    const [equipments, setEquipment]= useState({
        bathroom:[],
        vue:[],
        outside:[],
        bedroom:[],
        activities:[],
        reception:[],
        restaurant:[],
        security:[],
        general:[],
        health:[],
        internet:false,
        parking:false
    })
    const equipmentCategories = [
        { id: 'bathroom', label: 'Salle de bains' },
        { id: 'vue', label: 'Vue' },
        { id: 'outside', label: 'En extérieur' },
        { id: 'bedroom', label: 'Équipements en chambre' },
        { id: 'activities', label: 'Activités' },
        { id: 'reception', label: 'Réception' },
        { id: 'restaurant', label: 'Restauration' },
        { id: 'security', label: 'Sécurité' },
        { id: 'general', label: 'Général' },
        { id: 'health', label: 'Bien-être' },
        ];
    const addEquipmentItem = (id, value) => {
        if (!value.trim()) return;
        setEquipment(prev => ({
            ...prev,
            [id]: [...(prev[id] || []), value.trim()]
        }));
        };

const renderEquipmentInput = (id, label) => (
  <Form.Group className="mb-3" key={id}>
    <Form.Label className="fw-bold fs-5">{label}</Form.Label>
    <div className="d-flex mb-2">
      <Form.Control
        type="text"
        placeholder="Ajouter un équipement"
        value={equipmentInput[id] || ''}
        onChange={(e) =>
          setEquipmentInput(prev => ({ ...prev, [id]: e.target.value }))
        }
      />
      <Button
        variant="outline-primary"
        onClick={() => {
          addEquipmentItem(id, equipmentInput[id]);
          setEquipmentInput(prev => ({ ...prev, [id]: '' }));
        }}
        className="ms-2"
      >
        Ajouter
      </Button>
    </div>
    
    {/* Badges d’équipements */}
    <div className="d-flex flex-wrap gap-2">
      {equipments[id]?.map((item, i) => (
        <span
          key={i}
          className="badge bg-primary d-flex align-items-center"
          style={{ fontSize: "0.9rem", padding: "0.5rem 0.75rem", borderRadius: "20px" }}
        >
          {item}
          <XCircle
            className="ms-2"
            size={18}
            style={{ cursor: 'pointer' }}
            onClick={() => {
              setEquipment(prev => ({
                ...prev,
                [id]: prev[id].filter((_, idx) => idx !== i)
              }));
            }}
          />
        </span>
      ))}
    </div>
  </Form.Group>
);



    const [type, setType]= useState("")
    const [island, setIsland]= useState("")
    const months= [
        {month:0},{month:1},{month:2},{month:3},{month:4},{month:5},{month:6},{month:7},{month:8},{month:9},{month:10},{month:11},       
    ]

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
          // Send Axios request here
        }, 3000)
    
        return () => clearTimeout(delayDebounceFn)
      }, [equipments])

    const setCheckedType= (e, id)=> {
        const checked= e.target.checked
        setType(checked? id: null)
    }
    
    
    const setCheckedIsland= (e, id)=> {
        const checked= e.target.checked
        setIsland(checked? id: null)
    }
    console.log(island)

    useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
          console.log(photos)
          // Send Axios request here
        }, 3000)
    
        return () => clearTimeout(delayDebounceFn)
      }, [photos])

    const userId= userParams.userId

    const handlePhotoSelection = (e) => {
  const files = Array.from(e.target.files);
  setSelectedPhotos((prev) => [...prev, ...files]);
};


    
    const handleSubmit = async (event) => {
        event.preventDefault();
        event.stopPropagation();
        const csrfToken = await getCsrfToken(); // Récupérer le token CSRF

        const formData = new FormData();
        const name = document.getElementById('name').value;
        const adress = document.getElementById('adress').value;
        const city = document.getElementById('city').value;
        const desc = document.getElementById('desc').value;
        const cheapestPrice = document.getElementById('cheapestPrice').value;
        const apiUrl = document.getElementById('APIURL')?.value || "";
        const apiKey = document.getElementById('APIKEY')?.value || "";
    
        const pms = apiUrl && apiKey ? [{ apiUrl, apiKey }] : [];
        
        // Ajouter les données dans le FormData
        formData.append('name', name);
        formData.append('type', type);
        formData.append('island', island);
        formData.append('adress', adress);
        formData.append('city', city);
        formData.append('desc', desc);
        formData.append('cheapestPrice', cheapestPrice);
        formData.append('pms',  JSON.stringify(pms));
        formData.append('equipments', JSON.stringify(equipments));
    
        // Ajouter chaque fichier sélectionné
        selectedPhotos.forEach((photo) => formData.append("photos", photo));

        // Envoyer la requête POST
        try {
            const result = await axios.post(
                `https://api.komorotel.com/api/hotels/${userId}`,
                formData,
                {
                    withCredentials: true,
                    headers: {
                        'CSRF-Token': csrfToken // Ajouter le token CSRF
                    },
                }
            );
            console.log(result.data);
            if (result.data._id) {
                navigate(`/admin/${userId}/${result.data._id}`);
            }
        } catch (error) {
            console.error(error.response?.data || error.message);
        }
    };
    

       
    return(
        <Form onSubmit={e=> handleSubmit(e)}>
            <p className="fw-bold fs-4">Informations</p>
                <Row>
                    <Col >
                        <Form.Group controlId="name">
                            <Form.Label>Nom de l'hotel</Form.Label>
                            <Form.Control type="text"/>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="type">
                            <Form.Label>Type</Form.Label>
                            <div className="d-flex flex-column">
                                <div className="d-flex">
                                    <input className="form-check-input " type="checkbox" value="" disabled={type=== "Appartement&Maison"|| type==="Chambre d'hôte"} id="flexCheckIndeterminate" onChange={e => setCheckedType(e, "Hotel")} />
                                    <label className="form-check-label " for="flexCheckIndeterminate">
                                    Hotel
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <input className="form-check-input " type="checkbox" value="" disabled={type=== "Appartement&Maison"|| type==="Hotel"} id="flexCheckIndeterminate" onChange={e => setCheckedType(e, "Chambre d'hôte")} />
                                    <label className="form-check-label " for="flexCheckIndeterminate">
                                    Chambre d'hôte
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <input className="form-check-input " type="checkbox" disabled={type=== "Hotel"|| type==="Chambre d'hôte"} value="" id="flexCheckIndeterminate" onChange={e => setCheckedType(e, "Appartement&Maison")} />
                                    <label className="form-check-label " for="flexCheckIndeterminate">
                                    Appartement&Maison
                                    </label>
                                </div>
                            </div>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="adress">
                            <Form.Label>Adresse</Form.Label>
                            <Form.Control type="text"/>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="city">
                            <Form.Label>Ville</Form.Label>
                            <Form.Control type="text"/>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group controlId="island">
                            <Form.Label>Île</Form.Label>
                            <div className="d-flex flex-column">
                                <div className="d-flex">
                                    <input className="form-check-input " type="checkbox" value="" disabled={island=== "Anjouan"|| island==="Moheli"} id="flexCheckIndeterminate" onChange={e => setCheckedIsland(e, "Ngazidja")} />
                                    <label className="form-check-label " for="flexCheckIndeterminate">
                                    Ngazidja
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <input className="form-check-input " type="checkbox" value="" disabled={island=== "Ngazidja"|| island==="Moheli"} id="flexCheckIndeterminate" onChange={e => setCheckedIsland(e, "Anjouan")} />
                                    <label className="form-check-label " for="flexCheckIndeterminate">
                                    Anjouan
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <input className="form-check-input " type="checkbox" disabled={island=== "Anjouan"|| island==="Ngazidja"} value="" id="flexCheckIndeterminate" onChange={e => setCheckedIsland(e, "Moheli")} />
                                    <label className="form-check-label " for="flexCheckIndeterminate">
                                    Moheli
                                    </label>
                                </div>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Form.Group controlId="desc">
                            <Form.Label>Description</Form.Label>
                            <Form.Control as="textarea" rows={3}/>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>
                    <Col>
                    <Form.Group controlId="images" className="mb-3 d-flex flex-column justify-content-between h-100">
                        <Form.Label className="text-center mt-3">
                            Choisissez des images représentant votre hôtel <br />
                            <span className="fw-bold">
                            (Téléchargez une ou plusieurs images en même temps)
                            </span>
                        </Form.Label>
                        <Form.Control
                            type="file"
                            accept="image/*"
                            multiple
                            onChange={handlePhotoSelection}
                        />
                        <div className="mt-2 d-flex flex-wrap gap-2">
                            {selectedPhotos.map((photo, idx) => (
                            <img
                                key={idx}
                                src={URL.createObjectURL(photo)}
                                alt={`preview-${idx}`}
                                style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }}
                            />
                            ))}
                        </div>
                    </Form.Group>


                    </Col>
                    <Col >
                        <Form.Group controlId="cheapestPrice" className=" d-flex flex-column justify-content-between h-100"  >
                            <Form.Label className="text-center mt-3 w-100">Prix de la chambre la moins chère <br />(en KMF)</Form.Label>
                            
                            <InputGroup >
                                
                                <Form.Control
                                aria-describedby="basic-addon2"
                                type="number"
                                />
                                <InputGroup.Text id="basic-addon2">KMF</InputGroup.Text>
                            </InputGroup>
                        </Form.Group>
                    </Col>
                </Row>
                
                <p className="fw-bold fs-4 mt-3">Disposez-vous d'un système de réservation ?</p>
                    <div className="d-flex w-50 justify-content-between">
                        
                                <div className="d-flex">
                                    <input className="form-check-input me-1 " id="Choice1" type="radio" name="API" value="1" onChange={()=>updateVerifSystem(true)}/>
                                    <label className="form-check-label " >
                                    Oui
                                    </label>
                                </div>
                                <div className="d-flex">
                                    <input className="form-check-input me-1 " id="Choice2" type="radio" name="API" value="2" onChange={()=>updateVerifSystem(false)} />
                                    <label className="form-check-label " >
                                    Non
                                    </label>
                                </div>
                                
                    </div>
                    
                    {verifSystem===true && 
                    <Row className="mt-2">
                        <Col>
                            <Form.Group controlId="APIURL">
                                <Form.Label className="fw-bold">API URL</Form.Label>
                                <Form.Control type="text"/>
                            </Form.Group>
                        </Col>
                        <Col>
                            <Form.Group controlId="APIKEY">
                                <Form.Label className="fw-bold">API KEY</Form.Label>
                                <Form.Control type="text"/>
                            </Form.Group>
                        </Col>
                </Row>}
                


                <p className="fw-bold fs-4 mt-3">Equipement</p>

                <Row>
                    <Col md={4}>
                        {equipmentCategories.slice(0, 4).map(cat =>
                        renderEquipmentInput(cat.id, cat.label)
                        )}
                    </Col>
                    <Col md={4}>
                        {equipmentCategories.slice(4, 7).map(cat =>
                        renderEquipmentInput(cat.id, cat.label)
                        )}

                        {/* Internet checkbox */}
                        <Form.Group className="mt-3">
                        <Form.Check
                            type="checkbox"
                            label="Internet"
                            checked={equipments.internet}
                            onChange={e =>
                            setEquipment(prev => ({ ...prev, internet: e.target.checked }))
                            }
                        />
                        </Form.Group>
                    </Col>
                    <Col md={4}>
                        {equipmentCategories.slice(7).map(cat =>
                        renderEquipmentInput(cat.id, cat.label)
                        )}

                        {/* Parking checkbox */}
                        <Form.Group className="mt-3">
                        <Form.Check
                            type="checkbox"
                            label="Parking"
                            checked={equipments.parking}
                            onChange={e =>
                            setEquipment(prev => ({ ...prev, parking: e.target.checked }))
                            }
                        />
                        </Form.Group>
                    </Col>
                    </Row>

                <Button type="submit" className="mt-3 text-white">Confirmer</Button>
                
            </Form>
    )
}